<template>
  <page-wrapper :title="title">
    <div v-if="!$isCallCenter" class="header">
      <sc-button :route="createRoute" class="create-button" variant="primary"
        >เพิ่มหมวดหมู่</sc-button
      >
      <sc-button
        v-if="!$isCallCenter"
        :route="{ name: 'ServiceCategorySortPage' }"
        class="sort-button"
        variant="secondary"
        >จัดลำดับ</sc-button
      >
    </div>
    <category-list-item
      v-for="item in list"
      :key="item.id"
      v-bind="item"
    ></category-list-item>
  </page-wrapper>
</template>

<script>
import { backendAdminClient } from "@/dependencies";
import PageWrapper from "@/lib/components/PageWrapper";
import ScButton from "@/lib/components/ScButton";
import CategoryListItem from "../components/CategoryListItem";

export default {
  components: {
    PageWrapper,
    ScButton,
    CategoryListItem
  },
  data() {
    const title = "หมวดหมู่บริการ";
    const createRoute = { name: "ServiceCategoryCreatePage" };
    const list = [];

    return {
      title,
      list,
      createRoute
    };
  },
  created() {
    this.setup();
  },
  methods: {
    setup() {
      this.setupData();
    },
    setupData() {
      this.setupList();
    },
    async setupList() {
      try {
        this.list = await this.fetchList();
      } catch (error) {
        this.$message.error("ไม่สามารถโหลดข้อมูลหมวดหมู่บริการได้ กรุณาลองใหม่อีกครั้ง");
      }
    },
    async fetchList() {
      const response = await backendAdminClient.serviceCategory.getServiceCategoryList();

      return response.data.result.map((item) => this.mapListItem(item));
    },
    mapListItem(item) {
      return {
        id: item.id,
        name: item.name,
        iconUrl: item.icon,
        route: { name: "ServiceCategoryDetailPage", params: { id: item.id } },
        serviceCount: item.service_count,
      };
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";

.header {
  display: flex;
  justify-content: space-between;

  padding: 30px;
  border-bottom: $border;
}
</style>
